import esResources from './es-mx/index.js';
import enResources from './en-us/index.js';
export default Object.assign({}, enResources, esResources);
